import React from 'react';
import TranslatedText from '../../../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import useStyles from './styles';
import clsx from 'clsx';
import * as CurrencyUtils from '../../../../../../utils/currency';

interface IProps {
  totalVatAmountPayableServices: number;
  totalVatAmountPayableGoods: number;
}

const Totals = (props: IProps) => {
  const styles = useStyles();
  return (
    <React.Fragment>
      <TotalLine
        value={props.totalVatAmountPayableServices}
        label={'Services'}
        labelClass={clsx({
          [styles.label]: true,
          [styles.services]: true,
        })}
      />
      <TotalLine
        value={props.totalVatAmountPayableGoods}
        label={'Goods'}
        labelClass={clsx({
          [styles.label]: true,
          [styles.goods]: true,
        })}
      />
    </React.Fragment>
  );
};

interface ITotalProps {
  value: number;
  label: string;
  labelClass: any;
}

const TotalLine = (props: ITotalProps) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <TranslatedText textMap={Translations.footer_part1} />
      <span className={props.labelClass}>{props.label}</span>
      <TranslatedText textMap={Translations.footer_part2} />
      <div
        className={clsx({
          [styles.value]: true,
          [props.labelClass]: true,
        })}
      >
        {CurrencyUtils.formatCurrency(props.value)}
      </div>
    </div>
  );
};

export default Totals;
